import { CompanyStructure, SidebarItem } from '@/types'
import { MenuDataEnum } from '@/types/enums'
import { ProfitCenter } from '@/model/companyStructure/ProfitCenter'
import { Department } from '@/model/companyStructure/Department'
import { Employee } from '@/model/companyStructure/Employee'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import { AddressGroup } from '@/model/addresses/AddressGroup'
import { ProjectGroup } from '@/model/project/ProjectGroup'
import { ProductGroup } from '@/model/products/ProductGroup'

export function createSidebarFromResponse (data: CompanyStructure, sourceCategory: string | undefined): Array<SidebarItem> {
  let sidebar: Array<SidebarItem> = []

  const createSidebarItem = (data: Department | ProfitCenter | PlanningGroup | Employee, category: string): SidebarItem => {
    let departmentId = undefined
    if (category === MenuDataEnum.Employee) {
      // @ts-ignore
      departmentId = <Employee>data.department
    }
    let item: SidebarItem = {
      config: {},
      id: '',
      text: '',
      category: '',
      icon: '',
      children: []
    }

    item.id = data.id.toString()
    item.text = data.label
    item.category = category
    item.icon =
      category === MenuDataEnum.Employee
        ? 'perm_identity'
        : category === MenuDataEnum.Department ? 'store' : 'home'

    if (sourceCategory === MenuDataEnum.CompanyDataSettings) {
      item.route = `/settings/calendar-event-settings/${data.id}/`
    } else if (sourceCategory === MenuDataEnum.ProfitCenterSettingsWithDepartment && category === MenuDataEnum.Department) {
      item.route = `/settings/planning-groups-settings/${data.id}`
    } else if (category === MenuDataEnum.Employee) {
      item.route = `/employee-detail/${departmentId}/${data.id}`
    } else if (sourceCategory === MenuDataEnum.EmployeeHierarchySettings && category === MenuDataEnum.Department) {
      item.route = `/settings/employee-hierarchy/${data.id}`
    } else if (sourceCategory === MenuDataEnum.ProfitCenterAdditionalFieldsSettings) {
      item.route = `/settings/profit-center-additional-fields/${data.id}`
    } else {
      item.route = undefined
    }
    item.category = category
    item.children = []
    if(category === MenuDataEnum.Employee) {
      if(data instanceof Employee) {
        item.active = data.status
      }
    }
    return item
  }

  data.profitCenterList.forEach((pc: ProfitCenter) => {
    const type = sourceCategory === MenuDataEnum.CompanyData ? MenuDataEnum.ProfitCenter : MenuDataEnum.ProfitCenterSettings
    let profitCenter: SidebarItem = createSidebarItem(pc, type)

    if (sourceCategory === MenuDataEnum.CompanyData) {
      let departments: Array<SidebarItem> = data.departmentList
        .filter((d: Department) => d.profitCenterId === pc.id)
        .map((d: Department) => createSidebarItem(d, MenuDataEnum.Department))
      departments.forEach((d: SidebarItem) => {
        d.children = data.employeeList
          .filter((e: Employee) => e.department === parseInt(d.id))
          .map((e: Employee) => createSidebarItem(e, MenuDataEnum.Employee))
      })

      if (profitCenter && profitCenter.children) {
        profitCenter.children = profitCenter.children.concat(departments)
      }
    } else if (sourceCategory === MenuDataEnum.ProfitCenterSettingsWithDepartment || sourceCategory === MenuDataEnum.EmployeeHierarchySettings) {
      let departments: Array<SidebarItem> = data.departmentList
        .filter((d: Department) => d.profitCenterId === pc.id)
        .map((d: Department) => createSidebarItem(d, MenuDataEnum.Department))

      if (profitCenter && profitCenter.children) {
        profitCenter.children = profitCenter.children.concat(departments)
      }
    }

    sidebar.push(profitCenter)
  })

  return sidebar
}

export function createAddressSidebarItem (data: AddressGroup[], sourceCategory: string | undefined): Array<SidebarItem> {
  return data.map((item: AddressGroup) => {
    let sidebarItem: SidebarItem = {
      config: {
        showIcon: false
      },
      id: item.id.toString(),
      text: item.name,
      category: sourceCategory,
      icon: 'store',
      children: [],
    }

    if(sourceCategory === MenuDataEnum.AddressGroupItem) {
      sidebarItem.route = `/address/${item.id}`
    }

    return sidebarItem
  })
}

export function createProductSidebarItem (data: ProductGroup[], sourceCategory: string | undefined): Array<SidebarItem> {
  return data.map((item: ProductGroup) => {
    let sidebarItem: SidebarItem = {
      config: {
        showIcon: false
      },
      id: item.id.toString(),
      text: item.text,
      category: sourceCategory,
      icon: 'mdi-package-variant-closed',
      children: [],
    }

    if(sourceCategory === MenuDataEnum.ProductGroupItem) {
      sidebarItem.route = `/product/${item.id}`
    }

    return sidebarItem
  })
}

export function createProjectSidebarItem (data: ProjectGroup[], sourceCategory: string | undefined): Array<SidebarItem> {
  return data.map((item: ProjectGroup) => {
    let sidebarItem: SidebarItem = {
      config: {
        showIcon: false
      },
      id: item.id.toString(),
      text: item.text,
      category: sourceCategory,
      icon: 'mdi-ballot-outline',
      children: [],
    }

    if(sourceCategory === MenuDataEnum.ProjectGroupItem) {
      sidebarItem.route = `/project/${item.code}/${item.name.replace('/','-')}`
    }

    return sidebarItem
  })
}